import commonStyles from '../styles.module.scss'
import useStore from 'base/store'
import { PermissionType } from 'common/types'
import {Text, Button} from 'common/components'
import {useAcceptRequestStatus, useGetAML, CheckActionsProps} from '..'

export default function AMLCheckActions({
  // role,
  request,
  isRequestLoading,
}: CheckActionsProps) {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const isCoordinatorController = !!permissions?.includes('edit loan request (aml check)')
  const {data: aml} = useGetAML(request.project.uuid, isCoordinatorController)
  const {
    mutate: acceptRequestStatus,
    isMutating: isAcceptRequestStatusMutating,
  } = useAcceptRequestStatus(request.uuid)

  const handleStatusAccept = () => acceptRequestStatus()

  const btnDisable = aml?.some((item: any) => item.status !== 'approved') || isRequestLoading

  return (
    <div className={commonStyles.checkActions}>
      <Text size="xs">
        <Text as="span" weight="demiBold">
          Loan coordinator
        </Text>{' '}
        and{' '}
        <Text as="span" weight="demiBold">
          Financial controller
        </Text>{' '}
        need to do an AML check.
        <br />
        Automaticaly cancelled, if AML check can not be completed.
      </Text>
      {isCoordinatorController && (
        <Button
          loading={isAcceptRequestStatusMutating}
          disabled={
            (process.env.NODE_ENV === 'development') ? false :
            btnDisable
          }
          onClick={handleStatusAccept}
        >
          AML check done
        </Button>
      )}
    </div>
  )
}
